// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"90c51f28","337":"d03e3f7d","797":"14b911a7"}[chunkId] + ".chunk.css";
};